export enum EkonecVyporadani {
    N = 'N',
    P = 'P',
    NU = 'NU'
}
